

















import Vue from 'vue'
import { FilterItems } from '@/types/service-response'

interface ComponentData {
  selectedItem: { FilterItemId: number, FilterItemValue: string } | undefined
  selectRules: Array<(v: string) => string | boolean>
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingSelect',

  props: {
    focus: Boolean,
    name: String,
    label: String,
    items: {
      type: Array as () => Array<FilterItems>
    },
    defaulValue: String,
    isRequired: Boolean,
    isValid: Boolean
  },

  data (): ComponentData {
    return {
      selectedItem: undefined,
      selectRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ]
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        form.validate()
      }
    }
  },

  methods: {

    onSelectChange (): void {
      if (this.name && this.selectedItem && this.selectedItem.FilterItemValue) {
        let payload: Payload = { name: this.name, value: this.selectedItem.FilterItemId.toString(), label: this.selectedItem.FilterItemValue }
        this.$emit('onSelectChange', payload)
      }
    }
  },

  created () {
    if(this.focus) {
      setTimeout(() => {
        const field: any = this.$refs['field']
        if (field) {
          field.focus()
        }
      }, 0)
    }

    if (this.defaulValue) {
      this.selectedItem = { FilterItemId: 0, FilterItemValue: '' }
      this.selectedItem.FilterItemId = parseInt(this.defaulValue)
      let defaultName: FilterItems | undefined = this.items.find((item: FilterItems) => {
        return item.FilterItemId === this.selectedItem!.FilterItemId
      })
      if (defaultName) {
        this.selectedItem.FilterItemValue = defaultName.FilterItemValue
      }
      if (this.name && this.selectedItem.FilterItemValue) {
        let payload: Payload = { name: this.name, value: this.selectedItem.FilterItemId.toString(), label: this.selectedItem.FilterItemValue }
        this.$emit('onSelectChange', payload)
      }
    }
  }

})
